"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.notificationsRegistry = void 0;

var _ReducerRegistry = require("../../redux/ReducerRegistry");

var _notificationsInitialState = require("./notificationsInitialState");

/**
 * Registers the reducers and initial state for the permission area.
 * @description Typically used by reducers in the actions module (i.e folder) to register a reducer that will handle a redux action.
 * After all of the reducers are registers then getReducer can be called (typically by the redux store) that will handle all of the
 * redux actions.  The reducers in the area represent a shared state that an action can influence.
 */
var notificationsRegistry = new _ReducerRegistry.ReducerRegistry(_notificationsInitialState.notificationsInitialState);
exports.notificationsRegistry = notificationsRegistry;